import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Resizable } from 'components/atoms/resizable';
import { FilterBar } from 'components/molecules/filter-bar';
import { Page } from 'components/molecules/page';
import { StyledPage, Content, ContentWrapper, Layout, Progress, Sider, BannerWrapper } from './components';
export const Argon = ({ documentTitle, title, peel, tabs, sider, breadcrumbs, progress, content, extraContent, actions, className, isDistractionFree, hideHeader = false, whiteHeader, siderResizable, siderWidth, siderOffset, siderMaxWidth, siderMinWidth, onResize, onResizeStart, onResizeStop, banner, description, $island = false })=>{
    var _ref, _ref1;
    const [width, setWidth] = useState(siderWidth !== null && siderWidth !== void 0 ? siderWidth : 256);
    const { primary, secondary, central } = actions || {};
    return /*#__PURE__*/ _jsxs(StyledPage, {
        className: className,
        $island: $island,
        children: [
            peel != null ? /*#__PURE__*/ _jsx(Page.Peel, {
                children: peel
            }) : null,
            !hideHeader && /*#__PURE__*/ _jsx(Page.Header, {
                $white: whiteHeader,
                title: title,
                subText: description,
                breadcrumbs: breadcrumbs,
                tabs: tabs
            }),
            /*#__PURE__*/ _jsx(Helmet, {
                children: /*#__PURE__*/ _jsx("title", {
                    children: documentTitle
                })
            }),
            /*#__PURE__*/ _jsx(Page.Content, {
                children: /*#__PURE__*/ _jsxs(Layout, {
                    children: [
                        sider != null ? /*#__PURE__*/ _jsx(Resizable, {
                            initialWidth: width,
                            minWidth: siderMinWidth !== null && siderMinWidth !== void 0 ? siderMinWidth : 256,
                            maxWidth: siderMaxWidth !== null && siderMaxWidth !== void 0 ? siderMaxWidth : 600,
                            onChange: (w)=>{
                                setWidth(w);
                                onResize === null || onResize === void 0 ? void 0 : onResize(w);
                            },
                            offset: siderOffset !== null && siderOffset !== void 0 ? siderOffset : 0,
                            disabled: !siderResizable,
                            hideContent: isDistractionFree,
                            onResizeStart: onResizeStart,
                            onResizeStop: onResizeStop,
                            children: /*#__PURE__*/ _jsx(Sider, {
                                width: isDistractionFree ? 0 : width,
                                $border: !isDistractionFree,
                                children: sider
                            })
                        }) : null,
                        /*#__PURE__*/ _jsxs(Content, {
                            children: [
                                banner != null ? /*#__PURE__*/ _jsx(BannerWrapper, {
                                    id: "banner_wrapper",
                                    children: banner
                                }) : null,
                                ((_ref = primary !== null && primary !== void 0 ? primary : secondary) !== null && _ref !== void 0 ? _ref : central != null) ? /*#__PURE__*/ _jsxs(FilterBar, {
                                    children: [
                                        primary != null ? /*#__PURE__*/ _jsx(FilterBar.Primary, {
                                            children: primary
                                        }) : null,
                                        central != null ? /*#__PURE__*/ _jsx(FilterBar.Central, {
                                            children: central
                                        }) : null,
                                        secondary != null ? /*#__PURE__*/ _jsx(FilterBar.Secondary, {
                                            children: secondary
                                        }) : null
                                    ]
                                }) : null,
                                /*#__PURE__*/ _jsxs(ContentWrapper, {
                                    $full: ((_ref1 = primary !== null && primary !== void 0 ? primary : secondary) !== null && _ref1 !== void 0 ? _ref1 : central) == null,
                                    children: [
                                        /*#__PURE__*/ _jsx(Progress, {
                                            progress: progress
                                        }),
                                        content
                                    ]
                                }),
                                extraContent
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
